export default __webpack_public_path__ + "static/blood-92a98dd2ed537532c7cc4a460cfb31cb.png";